module.exports = __webpack_public_path__ + "../static/img/no-camera.38c6968d.png";